module.exports = __webpack_public_path__ + "static/media/noclass5.6e1b2dea.png";